import { GeneralConfigs } from '@caju-beneficios/sponsor-v2-lib/dist/configs'
import { UrlHelper } from '@caju-beneficios/sponsor-v2-lib/dist/lib/environment'
import { EnumProducts } from '@caju-beneficios/sponsor-v2-lib/dist/lib/environment/enumProducts'
import * as React from 'react'
import { Redirect, Route } from 'react-router-dom'

export interface RedirectToLoginProps {
  children?: any
}

export function RedirectToLogin(props: RedirectToLoginProps) {
  const needsPopupLogin = GeneralConfigs.needsPopupLogin()
  const loginUrl = UrlHelper.getUrl(EnumProducts.LOGIN, '')

  // ---------------------------------------------
  // Transformations
  // ---------------------------------------------
  // Render

  return (
    <Route render={() => {
      if (needsPopupLogin)
        return <Redirect to={'/login'} />

      window.location.assign(loginUrl)
      return null
    }} />
  )
}